'use strict';
const weightMap = {
		'light': '200',
		'semi-bold': '600'
	},
	fontWeightParser = function (fontObj) {
		if (!fontObj || !fontObj.weight) {
			return 'bold';
		}
		return weightMap[fontObj.weight] || fontObj.weight;
	},
	fontSizeParser = function (fontObj) {
		const fontSize = (fontObj && fontObj.size) || 12,
			lineSpacing = (fontObj && Number.isFinite(fontObj.lineSpacing)) ?  fontObj.lineSpacing : 3,
			lineHeight = (fontSize + lineSpacing) / fontSize;

		return fontSize + 'pt/' + lineHeight.toFixed(2);
	},
	fontFamilies = require('./font-families')(),
	fontParser = (fontObj, optional) => {
		if (!fontObj || !Object.keys(fontObj).length) {
			return false;
		}
		const family = (fontObj.family && fontFamilies[fontObj.family]) || fontFamilies.Sans;
		if (optional && optional.familyOnly) {
			return family;
		}
		return 'normal normal ' + fontWeightParser(fontObj) + ' ' +  fontSizeParser(fontObj) + ' ' + family;
	};

module.exports = fontParser;
